import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=72649bc4&scoped=true&"
import script from "./ListProjects.vue?vue&type=script&lang=js&"
export * from "./ListProjects.vue?vue&type=script&lang=js&"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=72649bc4&scoped=true&lang=css&"
import style1 from "./ListProjects.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72649bc4",
  null
  
)

export default component.exports